// src/constants/accountTypes.js

// Backend enum'u ile bire bir uyumlu değerler:
const ALL_ACCOUNT_TYPES = [
    { value: "CORPORATION",                    label: "Anonim Şirket" },
    { value: "SOLE_PROPRIETORSHIP",            label: "Şahıs İşletmesi" },
    { value: "ORDINARY_PARTNERSHIP",           label: "Adi Ortaklık" },
    { value: "COLLECTIVE_COMPANY",             label: "Kollektif Şirket" },
    { value: "COMMANDITE_COMPANY",             label: "Adi Komandit Şirket" },
    { value: "JOINT_STOCK_COMMANDITE_COMPANY", label: "Eshamlı Komandit Şirket" },
    { value: "JOINT_STOCK_COMPANY",            label: "Anonim Şirket" },
    { value: "LIMITED_COMPANY",                label: "Limited Şirket" },
    { value: "COOPERATIVE",                    label: "Kooperatif" },
    { value: "FOREIGN_PERSON",                 label: "Yabancı Kişi" },
    { value: "APARTMENT_MANAGEMENT",           label: "Apartman Yönetimi" },
    { value: "LAW_FIRM_PARTNERSHIP",           label: "Avukatlık Ortaklığı" },
    { value: "PRESS_ORGANIZATION",             label: "Basın" },
    { value: "UNION_OR_ASSOCIATION",           label: "Birlik ve Üst Birlik" },
    { value: "ASSOCIATION",                    label: "Dernek" },
    { value: "JOINT_VENTURE",                  label: "İş Ortaklığı" },
    { value: "TRADE_UNION",                    label: "Sendika" },
    { value: "SITE_MANAGEMENT",                label: "Site Yönetimi" },
    { value: "POLITICAL_PARTY",                label: "Siyasi Parti" },
    { value: "SPORTS_CLUB",                    label: "Spor Kulübü" },
    { value: "FOUNDATION",                     label: "Vakıf" },
    { value: "STATE_ECONOMIC_ENTERPRISE",      label: "Kamu İktisadi Teşebbüsü" },
    { value: "MUNICIPAL_ENTERPRISE",           label: "Belediye İktisadi Teşebbüsü" },
    { value: "GENERAL_PARTNERSHIP",            label: "Adi Ortaklık" },
];

// Enum'da aynı anlama gelen ikişer değer var (CORPORATION/JOINT_STOCK_COMPANY ve
// ORDINARY_PARTNERSHIP/GENERAL_PARTNERSHIP). Seçim listelerinde aynı etiket iki kez
// göründüğü için fazlalıkları gizliyoruz; eski kayıtlar doğru etiketle görünsün diye
// ALL_ACCOUNT_TYPES'ta duruyorlar.
const HIDDEN_ACCOUNT_TYPES = ["JOINT_STOCK_COMPANY", "GENERAL_PARTNERSHIP"];

// Seçim listeleri (filtre, cari oluşturma, rapor tipleri) bunu kullanır.
export const ACCOUNT_TYPES = ALL_ACCOUNT_TYPES.filter(
    (t) => !HIDDEN_ACCOUNT_TYPES.includes(t.value)
);

// Hızlı erişim için label map — gizlenenler dahil, kayıt görüntülemede gerekli.
export const ACCOUNT_TYPE_LABEL_MAP = ALL_ACCOUNT_TYPES.reduce((acc, cur) => {
    acc[cur.value] = cur.label;
    return acc;
}, {});

// Düzenleme formları için: kaydın mevcut türü gizlenmiş olsa bile seçenek listesinde
// kalsın, yoksa seçim boşa düşer ve kaydedince tür sessizce değişir.
export const accountTypeOptionsFor = (currentValue) => {
    if (!currentValue || ACCOUNT_TYPES.some((t) => t.value === currentValue)) {
        return ACCOUNT_TYPES;
    }
    return [
        ...ACCOUNT_TYPES,
        { value: currentValue, label: ACCOUNT_TYPE_LABEL_MAP[currentValue] || currentValue },
    ];
};

// UI için (opsiyonel) rozet renkleri
export const ACCOUNT_TYPE_BADGE_COLORS = {
    CORPORATION:                    "#0984E3",
    SOLE_PROPRIETORSHIP:            "#7AA7F5",
    ORDINARY_PARTNERSHIP:           "#9C88FF",
    COLLECTIVE_COMPANY:             "#20C997",
    COMMANDITE_COMPANY:             "#17A2B8",
    JOINT_STOCK_COMMANDITE_COMPANY: "#6F42C1",
    LIMITED_COMPANY:                "#00B894",
    COOPERATIVE:                    "#E17055",
    FOREIGN_PERSON:                 "#636E72",
    APARTMENT_MANAGEMENT:           "#55EFC4",
    LAW_FIRM_PARTNERSHIP:           "#FAB1A0",
    PRESS_ORGANIZATION:             "#E84393",
    UNION_OR_ASSOCIATION:           "#00CEC9",
    ASSOCIATION:                    "#81ECEC",
    JOINT_VENTURE:                  "#A29BFE",
    TRADE_UNION:                    "#FF7675",
    SITE_MANAGEMENT:                "#74B9FF",
    POLITICAL_PARTY:                "#D63031",
    SPORTS_CLUB:                    "#FDCB6E",
    FOUNDATION:                     "#2D3436",
    STATE_ECONOMIC_ENTERPRISE:      "#6C5CE7",
    MUNICIPAL_ENTERPRISE:           "#E17055",
    JOINT_STOCK_COMPANY:            "#71C29B",
    GENERAL_PARTNERSHIP:            "#9C88FF",
};

// İş kuralları için yardımcı (TC zorunluluğu kontrolü)
export const isSoleProprietorship = (value) => value === "SOLE_PROPRIETORSHIP";